"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _Textdomain2 = _interopRequireDefault(require("./Textdomain"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var withGettext = function withGettext() {
  var translations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var pluralForm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'n != 1';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (WrappedComponent) {
    var args = Object.assign({
      withRef: false
    }, options);

    var WithGettext = /*#__PURE__*/function (_Textdomain) {
      _inherits(WithGettext, _Textdomain);

      var _super = _createSuper(WithGettext);

      function WithGettext() {
        _classCallCheck(this, WithGettext);

        return _super.apply(this, arguments);
      }

      _createClass(WithGettext, [{
        key: "getWrappedComponent",
        value: function getWrappedComponent() {
          return this.refs.wrappedComponent;
        }
      }, {
        key: "render",
        value: function render() {
          var newprops = Object.assign({}, this.props);

          if (args.withRef) {
            newprops.ref = 'wrappedComponent';
          }

          return /*#__PURE__*/_react.default.createElement(WrappedComponent, newprops);
        }
      }]);

      return WithGettext;
    }(_Textdomain2.default);

    WithGettext.defaultProps = {
      translations: translations,
      plural: pluralForm
    };
    WithGettext.displayName = "withGettext(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");
    return (0, _hoistNonReactStatics.default)(WithGettext, WrappedComponent);
  };
};

var _default = withGettext;
exports.default = _default;